import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import CanoCompleto from './../../assets/images/icons/canoCompleto.png';
import { Box } from '@mui/material';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const LogoMain = ({ reverse }) => {
  const theme = useTheme();
  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={theme.palette.mode === 'dark' ? logoDark : logo} alt="Mantis" width="100" />
     *
     */
    <Box width="130" height="57" viewBox="0 0 130 57" fill="none">
      <img
        alt="Cano Logo"
        style={{
          width: '130px',
          height: '57px',
          filter: theme.palette.mode === 'dark' || reverse ? 'invert(1)' : 'invert(-0)'
        }}
        src={CanoCompleto}
      ></img>
    </Box>
  );
};

LogoMain.propTypes = {
  reverse: PropTypes.bool
};

export default LogoMain;
